// Server domain address

const config = {
  URI: 'https://workshop.tokyo',
  VIDEO_URL: 'https://video.workshop-live.com',
  ADMIN_URL: 'https://admin.workshop-live.com',
  STRIPE_KEY: 'pk_live_cauKFyxZ4BmqW9gwxxLowNrn',
  PREMIUM: "plan_DFT2dZYJZdq9aK",
  FREE: "plan_DFT0cvjayrieOl",
  PLANS: {
    free: 'Free',
    free_admin: 'Free',
    free_guest: 'Free',
    guest: 'Free',
    starter_month: 'Starter monthly',
    starter_year: 'Starter yearly',
    premium_month: 'Premium monthly',
    premium_year: 'Premium yearly'
  },
  FVlite_DEBUG: false,
  FIREBASE_CONFIG: {
    apiKey: "AIzaSyDsddDaw6PK6UO_Ht8m5Blq5uTrAHnPOO8",
    authDomain: "workshop-video-prod.firebaseapp.com",
    databaseURL: "https://workshop-video-prod.firebaseio.com",
    projectId: "workshop-video-prod",
    storageBucket: "workshop-video-prod.appspot.com",
    messagingSenderId: "447629060783"
  },
  SENTRY: "https://a6e318e77a46405cb7cce7e3deec53e1@sentry.io/1477153",
  GIT_HASH: "f4dda8a",
  GIT_BRANCH: "release"
};

export default config;



// WEBPACK FOOTER //
// ./src/config/config.js